import { MosaicProvider } from '@opendoor/mosaic';
import { ApolloProvider } from '@apollo/client';
import { clientFromUrl } from './setupAthenaClient';
import { SessionProvider } from './contexts/SessionContext';
import NavigationBar from './components/NavigationBar';
import ErrorBoundary from './contexts/ErrorBoundary';
import VerticalLayout from './components/layouts/VerticalLayout';
import Profile from './pages/Profile';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import Visits from './pages/Visits';
import MaintenanceInvoicePage from './pages/MaintenanceInvoicePage';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

const App = () => (
  <MosaicProvider>
    <ApolloProvider client={clientFromUrl()}>
      <VerticalLayout className="w-100% h-100% bg-white">
        <NavigationBar />
        <SessionProvider>
          <ErrorBoundary>
            <BrowserRouter>
              <QueryParamProvider adapter={ReactRouter6Adapter}>
                <Routes>
                  <Route path="/" element={<Profile />} />
                  <Route path="/visits" element={<Visits />} />
                  <Route path="/maintenance" element={<MaintenanceInvoicePage />} />
                </Routes>
              </QueryParamProvider>
            </BrowserRouter>
          </ErrorBoundary>
        </SessionProvider>
      </VerticalLayout>
    </ApolloProvider>
  </MosaicProvider>
);

export default App;
